import React from 'react'
import { customFilter } from 'react-bootstrap-table2-filter'
import HeaderSearchBar from './HeaderSearchBar'
import { formatedDate } from '../../utils/formatedDate'
let articleNumberFilter
let articleNameFilter
let sizeNameFilter
let serialkeyFilter
let batchKeyFilter
let storehouseCoordinatesOrNameFilter

export function clearFilter() {
  articleNumberFilter(null)
  articleNameFilter(null)
  sizeNameFilter(null)
  serialkeyFilter(null)
  batchKeyFilter(null)
  storehouseCoordinatesOrNameFilter(null)
}
export const columns = [
  {
    dataField: 'checkBox',
    text: '',
    sort: false,
    editable: false,
    headerClasses: 'checkBox-header-cell',
    classes: 'checkBox-cell',
  },
  {
    dataField: 'articleNumber',
    text: 'localInventoriesTable:articleNumber',
    sort: true,
    editable: false,
    filterKey: 'filter.articleNumber',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => (
      <HeaderSearchBar
        onFilter={onFilter}
        column={column}
        getFilter={(filter) => {
          articleNumberFilter = filter
        }}
      />
    ),
  },
  {
    dataField: 'articleName',
    text: 'localInventoriesTable:articleName',
    sort: true,
    editable: false,
    filterKey: 'filter.articleName',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => (
      <HeaderSearchBar
        onFilter={onFilter}
        column={column}
        getFilter={(filter) => {
          articleNameFilter = filter
        }}
      />
    ),
  },
  {
    dataField: 'sizeName',
    text: 'localInventoriesTable:sizeName',
    sort: true,
    editable: false,
    filterKey: 'filter.sizeName',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => (
      <HeaderSearchBar
        onFilter={onFilter}
        column={column}
        getFilter={(filter) => {
          sizeNameFilter = filter
        }}
      />
    ),
  },
  {
    dataField: 'serialkey',
    text: 'localInventoriesTable:serialkey',
    sort: true,
    editable: false,
    filterKey: 'filter.serialkey',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => (
      <HeaderSearchBar
        onFilter={onFilter}
        column={column}
        getFilter={(filter) => {
          serialkeyFilter = filter
        }}
      />
    ),
  },
  {
    dataField: 'batchKey',
    text: 'localInventoriesTable:batchKey',
    sort: true,
    editable: false,
    filterKey: 'filter.batchKey',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => (
      <HeaderSearchBar
        onFilter={onFilter}
        column={column}
        getFilter={(filter) => {
          batchKeyFilter = filter
        }}
      />
    ),
  },
  {
    dataField: 'expiryDate',
    text: 'localInventoriesTable:expiryDate',
    sort: true,
    editable: false,
    headerClasses: 'top-header-cell',
    formatter: (cell, row) => formatedDate(cell),
  },
  {
    dataField: 'warrantyDate',
    text: 'localInventoriesTable:warrantyDate',
    sort: true,
    editable: false,
    headerClasses: 'top-header-cell',
    formatter: (cell, row) => formatedDate(cell),
  },
  {
    dataField: 'storehouseCoordinates',
    text: 'localInventoriesTable:storehouseCoordinates',
    sort: true,
    editable: false,
    filterKey: 'filter.storehouseCoordinatesOrName',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => (
      <HeaderSearchBar
        onFilter={onFilter}
        column={column}
        getFilter={(filter) => {
          storehouseCoordinatesOrNameFilter = filter
        }}
      />
    ),
  },
  {
    dataField: 'storehouseName',
    text: 'localInventoriesTable:storehouseName',
    sort: true,
    editable: false,
    filterKey: 'filter.storehouseName',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => (
      <HeaderSearchBar
        onFilter={onFilter}
        column={column}
        getFilter={(filter) => {
          storehouseCoordinatesOrNameFilter = filter
        }}
      />
    ),
  },
  {
    dataField: 'quantity',
    text: 'localInventoriesTable:currentInventory',
    sort: true,
    editable: false,
    headerClasses: 'top-header-cell',
    formatter: (cell, row, rowIndex, extraProps) => (
      <>
        <div>
          {row.quantity} {row.capacityUnitName}
        </div>
      </>
    ),
  },
]
